import { IconLayer } from "@deck.gl/layers"
import { selectWorkspaceMembers } from "features/entity-caching/members/UserManagementSlice"
import { selectUserLocationSharesMap } from "features/entity-caching/flights/selectors"
import {
    selectOpenUserLocationShareIds,
    selectUserLocationShareNodeEnabledMap,
} from "plugins/UserLocationShare/state/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { useMemo } from "react"
import {
    USER_LOCATION_ICON_SIZE,
    userLocationIconStore,
    useUserLocationIconsVersion,
} from "./userLocationIconStore"
import { userLocationSharePlaybackStore } from "./userLocationSharePlaybackStore"

export const useUserLocationSharePlaybackLayers = () => {
    const openIds = useAppSelector(selectOpenUserLocationShareIds)
    const playbackByShareId = userLocationSharePlaybackStore.useAll()
    const shares = useAppSelector(selectUserLocationSharesMap)
    const members = useAppSelector(selectWorkspaceMembers)
    const nodeEnabledByShareId = useAppSelector(selectUserLocationShareNodeEnabledMap)
    const iconsVersion = useUserLocationIconsVersion()

    return useMemo(() => {
        void iconsVersion
        return openIds.flatMap((id) => {
            const playback = playbackByShareId.get(id)
            const share = shares[id]
            const userId = share?.createdBy?.userId
            if (!playback || !userId || nodeEnabledByShareId[id] === false) return []

            const member = members?.find((m) => m.userId === userId)
            const iconUrl = userLocationIconStore.get({
                userId,
                fullName: member?.fullName,
                profilePhotoS3Key: member?.profilePhotoS3Key,
            })

            const markerLayer = new IconLayer({
                id: `user-location-share-marker-${id}`,
                data: [playback.current],
                pickable: false,
                getPosition: (d) => [d.longitude, d.latitude],
                getIcon: () => ({
                    url: iconUrl,
                    width: USER_LOCATION_ICON_SIZE,
                    height: USER_LOCATION_ICON_SIZE,
                    anchorX: USER_LOCATION_ICON_SIZE / 2,
                    anchorY: USER_LOCATION_ICON_SIZE / 2,
                }),
                getAngle: (d) => (d.heading == null ? 0 : -d.heading),
                sizeUnits: "pixels",
                sizeScale: 1,
                billboard: false,
                getSize: () => 48,
            })

            return [markerLayer]
        })
    }, [openIds, playbackByShareId, shares, members, nodeEnabledByShareId, iconsVersion])
}
